/* eslint-disable */
var React = require('react');
var SpriteSymbol = require("../../../svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../svg-sprite-loader/runtime/browser-sprite.build.js");

var symbol = new SpriteSymbol({
  "id": "flag-24a525cd--sprite",
  "use": "flag-24a525cd--sprite-usage",
  "viewBox": "0 0 36 36",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 36 36\" id=\"flag-24a525cd--sprite\">\r\n  <defs>\r\n    <clipPath id=\"flag-24a525cd--sprite_clip-Flag\">\r\n      <rect width=\"36\" height=\"36\" />\r\n    </clipPath>\r\n  </defs>\r\n  <g id=\"flag-24a525cd--sprite_Flag\" clip-path=\"url(#flag-24a525cd--sprite_clip-Flag)\">\r\n    <g id=\"flag-24a525cd--sprite_Rectangle_9217\" data-name=\"Rectangle 9217\" fill=\"#fff\" stroke=\"#707070\" stroke-width=\"1\" opacity=\"0\">\r\n      <rect width=\"36\" height=\"36\" stroke=\"none\" />\r\n      <rect x=\"0.5\" y=\"0.5\" width=\"35\" height=\"35\" fill=\"none\" />\r\n    </g>\r\n    <g id=\"flag-24a525cd--sprite_Component_60_7\" data-name=\"Component 60 – 7\" transform=\"translate(14 12)\">\r\n      <g id=\"flag-24a525cd--sprite_Group_4671\" data-name=\"Group 4671\">\r\n        <path id=\"flag-24a525cd--sprite_Path_2366\" data-name=\"Path 2366\" d=\"M1865.55,1020.164v4.14a.487.487,0,0,1-.5.484h-3.22a.487.487,0,0,1-.5-.484v-.542h-3.17v6.554a.5.5,0,0,1-1,0v-11.033a.487.487,0,0,1,.5-.484h4.22a.487.487,0,0,1,.5.484v.4h2.67A.487.487,0,0,1,1865.55,1020.164Z\" transform=\"translate(-1857.16 -1018.8)\" fill=\"currentColor\" />\r\n      </g>\r\n    </g>\r\n  </g>\r\n</symbol>"
});
sprite.add(symbol);

var SvgSpriteIcon = function SvgSpriteIcon(props) {
  return React.createElement(
    'svg',
    Object.assign({
      viewBox: symbol.viewBox
    }, props),
    React.createElement(
      'use',
      {
        xlinkHref: '#' + symbol.id
      }
    )
  );
};

SvgSpriteIcon.viewBox = symbol.viewBox;
SvgSpriteIcon.id = symbol.id;
SvgSpriteIcon.content = symbol.content;
SvgSpriteIcon.url = symbol.url;
SvgSpriteIcon.toString = symbol.toString;

module.exports = SvgSpriteIcon;
module.exports.default = SvgSpriteIcon;
